import { DEFAULT_CRM_TOKEN, portalHomeUrl } from './constants';
const privateSubmissionBaseUrl = 'https://agency.comcate.com/private-submission';
const logoutRedirectUrl = encodeURIComponent(portalHomeUrl);
export const crmToken = DEFAULT_CRM_TOKEN;
export function privateSubmissionUrl(path) {
    if (!crmToken) {
        return '';
    }
    return `${privateSubmissionBaseUrl}/${path}?crm_token=${crmToken}&logout_redirect_url=${logoutRedirectUrl}`;
}
export const submitRequestUrl = privateSubmissionUrl('create');
export const loginToAccountUrl = privateSubmissionUrl('listing');
export const viewAllRequestsUrl = privateSubmissionUrl('public-map');
